import { useState } from "react";
import {Form} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css';
import { useNavigate } from "react-router-dom";
import {postDataFreeAccess} from '../middleware/apiMiddleware';
import {setJWTToken} from '../middleware/dataStorage';

export default function Login() {	
	const navigate = useNavigate();
	
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [errorMsg, setErrorMsg] = useState("");
	
	const userLogin = async (e) => {
    e.preventDefault();
		let obj = {username,password };
		let res = await postDataFreeAccess("login", obj);
		if (!res.success) {
			setErrorMsg(res.jsError);
		} else {
			setJWTToken(res.jwtToken);
			navigate('/');
		}
	}
	
	return (
		<div id="test">
			<img id="bg" alt="" src="https://ehla-media-bucket.s3.amazonaws.com/thumbnail_201706/shutterstock425265913-1506685801815.jpg"/>
			<div id="content">
				<div id="title">
					<p>EHLA CMS</p>
				</div>
				<div style={{padding:"20px", borderRadius: "5px", border: "2px solid #73AD21"}}>
					<Form>
						<Form.Group className="mb-3" controlId="formBasicEmail">
							<Form.Label>Username</Form.Label>
							<Form.Control 
								type="text"  
								placeholder="Enter username" 
								onChange={(d)=>setUsername(d.target.value)}/>
						</Form.Group>

						<Form.Group className="mb-3" controlId="formBasicPassword">
							<Form.Label>Password</Form.Label>
							<Form.Control 
								type="password" 
								placeholder="Password"
								onChange={(d)=>setPassword(d.target.value)} />
						</Form.Group>
						<p id="errorMsg">{errorMsg}</p>
						<button onClick={userLogin} className="billBtn billBtn-default"   style={{ height:"100%", width:"80px"}}>Login</button>
					</Form>
				</div>	
			</div>	
		</div>
	);
}